import { Modal, Result } from 'antd';
import { useMediaQuery } from 'react-responsive';
import { atom } from 'jotai';
import { useDialog } from '~/hooks';
import { useApplicationContext } from '../ApplicationContext';

function useIsMobile() {
    return useMediaQuery({ query: '(max-width: 768px)' });
}

const getSubscriptionDialog = atom(false);

export function useGetSubscriptionDialog() {
    return useDialog(getSubscriptionDialog);
}

export default function GetSubscriptionModal() {
    const { isTeams } = useApplicationContext()!;
    const { isOpened, closeDialog } = useGetSubscriptionDialog();
    const isMobile = useIsMobile();

    const isTeamsOnMobile = isMobile && isTeams;

    return (
        <Modal
            centered
            open={isOpened}
            destroyOnClose={true}
            onOk={() => {}}
            width={'100vw'}
            classNames={{ body: 'h-full' }}
            style={{
                height: '100vh',
                padding: 0,
                top: 0,
                left: 0,
                margin: 0,
                borderRadius: 0,
                maxWidth: '100%',
            }}
            onCancel={closeDialog}
            modalRender={(node) => (
                <div className='full-screen-dialog w-full h-screen'>{node}</div>
            )}
            footer={null}>
            {isTeamsOnMobile && (
                <Result
                    status='warning'
                    title='Use Desktop app to Purchase subscription'
                    subTitle="Sorry, you can't purchase a subscription on your mobile
                device. Please open the app on your desktop to purchase a
                subscription."
                />
            )}

            {!isTeamsOnMobile && (
                <iframe
                    title='Pricing'
                    src='/iframe/pricing'
                    className='w-full h-full border-none'></iframe>
            )}
        </Modal>
    );
}
